import React from 'react';
import { MODAL_TYPES, useModal } from './ModalProvider';

export default function SecondarySelectorModalWrapper({
  isOpen,
  onClose,
  modalContent,
  modalHeading
}) {
  const { modalUtils, getCloseButton } = useModal();
  return modalUtils.createModalWrapper({
    modalType: MODAL_TYPES.secondarySelector,
    isOpen,
    onClose,
    containerClassName: modalUtils.containerPresets.standard.basic,
    children: (
      <>
        {getCloseButton(MODAL_TYPES.secondarySelector, onClose)}
        {modalHeading ? (
          <div className="h4 text-parlor-green pb-5 text-center">
            {modalHeading}
          </div>
        ) : null}
        <div
          className={`rte text-black ${!modalHeading ? 'pt-2' : ''}`}
          dangerouslySetInnerHTML={{ __html: modalContent }}
        />
      </>
    )
  });
}
